import { css } from 'styled-components'

import { helpers } from './theme'

export default css`
	h1,
	h2,
	h3,
	h4,
	h5 {
		margin: 0 0 1.05rem;
		color: ${helpers.color.text};
	}

	h1 {
		font: ${helpers.fonts.headline.largest};
	}

	h2 {
		font: ${helpers.fonts.headline.large};
	}

	h3 {
		font: ${helpers.fonts.headline.medium};
	}

	h4 {
		font: ${helpers.fonts.headline.small};
	}

	p {
		margin: 0 0 10px;
	}

	ul {
		margin: 0;
		padding: 0;
	}
`
